import { render, staticRenderFns } from "./CandidatosOpcao.vue?vue&type=template&id=13270d8e&scoped=true&"
import script from "./CandidatosOpcao.vue?vue&type=script&lang=js&"
export * from "./CandidatosOpcao.vue?vue&type=script&lang=js&"
import style0 from "./CandidatosOpcao.vue?vue&type=style&index=0&id=13270d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13270d8e",
  null
  
)

export default component.exports